import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyJoin } from "@/components/MatchKey/MatchKeyShell";
import { CHECKERS_CFG } from "@/components/MatchKey/cfgs";

export default function CheckersJoinPage() {
  useEerieBackdrop("estampie");
  return <MatchKeyJoin cfg={CHECKERS_CFG} />;
}
